import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

export default new Vuex.Store({
    state: {
        //TODO: don't store these in state. when conf is changed state remains cached
        // valChrom_base_url: process.env.VUE_APP_VALCHROM_BASE_URL,
        valChrom_domain: process.env.VUE_APP_VALCHROM_DOMAIN,
        
        overview_simplify: true,
        jwt: localStorage.getItem('valchrom-token') || '',
        user: localStorage.getItem('valchrom-user') || null,
        token_expiry: localStorage.getItem('valchrom-token-expiry') || null,

        column_headers: ["name", "expected conc.", "level", "parallel", "rt", "change (rt)", "sd (rt)", "rsd (rt)", "mean [change (rt)]", "rsd [change (rt)]", "area", "mean (area)", "sd (area)", "rsd (area)", "n", "change (n)", "mean[change (n)]", "rsd [change (n)]", "mass", "precursor ion", "product ion", "rs", "change (rₛ)", "mean [change (rₛ)]","rsd [change (rₛ)]", "aₛ", "change (aₛ)", "mean [change (aₛ)]", "rsd [change (aₛ)]", "k", "change (k)", "mean [change (k)]", "rsd [change (k)]", "experimental conc.", "mean (concentration)", "sd (concentration)", "rsd (concentration)", "residual", "back calc. conc.", "error (back calc. conc.)", "data for trueness", "trueness", "sd (data for trueness)", "rsd (data for trueness)", "is area", "is expected conc.", "is area ratio", "is expected conc. ratio", "slope", "sd (slope)", "intercept", "sd (intercept)", "r²", "rss", "marker", "ccα", "ccβ", "y (critical)", "sₓₓ", "df", "t (α, df)", "δ", "x (d0)", "x (d1)", "x (d2)", "x (d3)", "sₓₓ (weighed)", "sᵢ", "σ₁ᵢ", "σ₂ᵢ", "σ₃ᵢ", "σ (xd0)", "σ (xd1)", "σ (xd2)", "σ (xd3)", "σ₀", "d"],

        validation_parameters: ['Selectivity', 'LoD and LoQ', 'Linear Range', 'Precision', 'Accuracy', 'Robustness', 'Ruggedness', 'System Suitability Testing'],

        //to hold the id of the current object. for cases where user goes back
        method_id:0,
        validation_plan_template_id:0,
        experimental_plan_id:0,
        experimental_dataset_id:0,        
        report_id:0,
        
        //to hold the object of the current entity.
        experimental_data_object:{},
        experimental_plan_object: {},
        overview_object:{},
        assessment_method_object:{},
        new_report_object:{},

        //to hold the navigation trail of a user for breadcrumb display 
        breadcrumb: []
    },
    plugins: [vuexLocal.plugin],
    mutations: {//TODO make state type-safe
        CHANGE_METHOD_ID: (state : any, id) => {
            state.method_id = id
        },
        CHANGE_OVERVIEW_SIMPLIFY: (state : any, val: boolean) => {
            state.overview_simplify = val
        },
        CHANGE_OVERVIEW_OBJECT: (state, object) => {
            state.overview_object = object
        },
        CHANGE_ASSESSMENT_METHOD_OBJECT: (state, object) => {
            state.assessment_method_object = object
        },
        CHANGE_NEW_REPORT_OBJECT: (state, object) => {
            state.new_report_object = object
        },
        CHANGE_REPORT_ID: (state, id) => {
            state.report_id = id
        },
        CHANGE_VALIDATION_PLAN_TEMPLATE_ID: (state, id) => {
            state.validation_plan_template_id = id
        },
        CHANGE_EXP_PLAN_ID: (state, id) => {
            state.experimental_plan_id = id
        },
        CHANGE_EXPERIMENTAL_DATASET_ID: (state, id) => {
            state.experimental_dataset_id = id 
        },
        CHANGE_EXPERIMENTAL_DATA_OBJECT: (state, obj) => {
            state.experimental_data_object = obj 
        },
        CHANGE_EXPERIMENTAL_PLAN_OBJECT: (state, obj) => {
            state.experimental_plan_object = obj 
        },
        SET_BREADCRUMB: (state, breadcrumb) => {
            state.breadcrumb = breadcrumb
        },
        AUTH_SUCCESS: (state, payload) => {
            state.jwt = payload.token
            state.user = payload.user
            state.token_expiry = payload.token_expiry;
        },
        UPDATE_USER: (state, payload) => {
            localStorage.setItem('valchrom-user', payload.user)
            state.user = payload.user
        },
        REFRESH_TOKEN: (state, payload) => {
            localStorage.setItem('valchrom-token', payload.token)
            localStorage.setItem("valchrom-token-expiry", payload.token_expiry);
            state.jwt = payload.token
            state.token_expiry = payload.token_expiry
        },
        LOGOUT: (state) => {
            state.jwt = ''
            state.user = null
            state.token_expiry = null
        }
    },
    getters: {
        overview_simplify (state) {
            return state.overview_simplify
        },
        base_url (state) {
            return process.env.VUE_APP_VALCHROM_BASE_URL
        },
        mathservice_start_date(state){
            return "2020-11-10";
        },
        math_service_url (state) {
            return process.env.VUE_APP_MATH_SERVICE_DOMAIN
        },
        domain (state) {
            return state.valChrom_domain
        },
        current_user (state) {
            return state.user
        },
        authenticated (state) {
            return !!(state.jwt && state.token_expiry);
        },
        auth_header (state) {
            return {
                  "Authorization": `JWT ${state.jwt}`
            }
        },
        token (state) {
            return state.jwt;
        },
        token_expiry (state) {
            return state.token_expiry;
        },
        columnHeaders(state) {
            return state.column_headers
        },
        validationParameters(state) {
            return state.validation_parameters
        },
        currentMethodID(state) {
            return state.method_id
        },
        currentOverviewObject(state) {
            return state.overview_object
        },
        currentAssessmentMethodObject(state) {
            return state.assessment_method_object
        },
        currentNewReportObject(state) {
            return state.new_report_object
        },
        currentReportID(state) {
            return state.report_id
        },
        currentValidationPlanTemplateID(state) {
            return state.validation_plan_template_id
        },
        currentExpPlanID(state) {
            return state.experimental_plan_id
        },
        currentExperimentalDatasetID(state) {
            return state.experimental_dataset_id
        },
        currentExperimentalDataObject(state) {
            return state.experimental_data_object
        },
        currentExperimentalPlanObject(state) {
            return state.experimental_plan_object
        },
        currentBreadcrumb(state) {
            return state.breadcrumb
        }
    },
    actions: {
        login ( {commit}, payload) {
            commit('AUTH_SUCCESS', payload)
        },
        logout ({ commit }) {
            commit('LOGOUT')
        },
        update_user ({commit}, payload) {
            commit('UPDATE_USER', payload)
        },
        refresh_token ({commit}, payload) {
            commit('REFRESH_TOKEN', payload)
        }
    }
})